export function useNIF() {
  function nifFetch(banners, options) {
    if (process.env.VUE_APP_BANNERS_USE_NIF != "true") return;
    window.adn.clearDivs();

    const adUnits = banners.reduce((arr, b) => {
      if (b.contentType == "EXTERNAL_NIF") {
        const { placementId, adUnitId } = getNIFMeta(b);
        arr.push([placementId, adUnitId]);
      }
      return arr;
    }, []);

    if (adUnits.length == 0) return;

    window.adn.calls.push(function () {
      window.nifRequestAds(adUnits);
    });
  }

  function getNIFMeta(banner) {
    const [placementId, adUnitId] = banner.contentText.split("/");
    return {
      placementId,
      adUnitId
    };
  }

  return {
    nifFetch,
    getNIFMeta
  };
}
